import { useMutation, useQueryClient } from "@tanstack/react-query";
import { revokeToken } from "@/lib/api/tokens";
import { toast } from "sonner";
import { getErrorMessage } from "@/utils/errorMessages";

export function useRevokeToken() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (tokenId: string) => revokeToken(tokenId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["tokens"] });
      toast.success("Token revoked successfully");
    },
    onError: (error: Error) => {
      const message = getErrorMessage(error);
      toast.error(message);
    },
  });
}
